import React from 'react';
import CityPage from './CityPage';

const MobileCarWashDubai = () => <CityPage cityId="dubai" />;

export default MobileCarWashDubai;
